<template>
  <div class="balance">
    <h6 class="balance__title">{{ t('profile.balance.title') }}</h6>
    <div class="balance__current">
      <h6>{{ t('profile.balance.current') }}: </h6>
      <p><img src="@icons/currency.svg" alt="currency"> {{ userBalance }}</p>
    </div>
    <div class="balance__block">
      <h6>{{ t('profile.balance.topUp') }}</h6>
      <div class="balance__block-inner">
        <div>
          <img src="@icons/currency.svg" alt="currency">
          <input
              type="text"
              v-model="amount"
              @input="validateNumberInput"
          >
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="24" viewBox="0 0 44 24" fill="none">
          <path d="M2 13.5C1.17157 13.5 0.5 12.8284 0.5 12C0.5 11.1716 1.17157 10.5 2 10.5L2 13.5ZM43.0607 10.9393C43.6464 11.5251 43.6464 12.4749 43.0607 13.0607L33.5147 22.6066C32.9289 23.1924 31.9792 23.1924 31.3934 22.6066C30.8076 22.0208 30.8076 21.0711 31.3934 20.4853L39.8787 12L31.3934 3.51472C30.8076 2.92893 30.8076 1.97919 31.3934 1.3934C31.9792 0.807614 32.9289 0.807614 33.5147 1.3934L43.0607 10.9393ZM2 12L2 10.5L42 10.5L42 12L42 13.5L2 13.5L2 12Z" fill="#F3F3F3"/>
        </svg>
        <div>
          <p>EUR</p>
          <input
              type="text"
              v-model="amount"
              @input="validateNumberInput"
          >
        </div>
      </div>
    </div>
    <i18n-t class="balance__text" tag="p" scope="global" keypath="profile.balance.text">
      <template #paymentGatewayMinimum>
        <span>{{ company.paymentGatewayMinimum }}</span>
      </template>
      <template #paymentGatewayMaximum>
        <span>{{ company.paymentGatewayMaximum }}</span>
      </template>
    </i18n-t>
    <div class="balance__checkboxes">
      <ui-checkbox
          v-model="isAgreePolicy"
          :id="1"
      >
        <p>
          {{ t('checkboxes.accept') }}
          <router-link :to="translations.i18nRoute({ name: 'home' })" class="balance__link">
            {{ t('docs.terms.title') }}
          </router-link>
        </p>
      </ui-checkbox>
      <ui-checkbox
          v-model="isAgreeTerms"
          :id="2"
      >
        <p>
          {{ t('checkboxes.accept') }}
          <router-link :to="translations.i18nRoute({ name: 'policy' })" class="balance__link">
            {{ t('docs.policy.title') }}
          </router-link>
        </p>
      </ui-checkbox>
    </div>
    <router-link :to="translations.i18nRoute({ name: 'checkout', query: { amount: amount }})">
      <ui-button
          class="balance__button"
          :isDisabled="!isFormValid"
      >
        {{ t('buttons.topUp') }}
      </ui-button>
    </router-link>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useAuthStore} from "@/stores/auth.js";
import {useCompanyStore} from "@/stores/company.js";
import translations from "@/core/helpers/translations.js";
import UiCheckbox from "@/components/ui/ui-checkbox.vue";
import UiButton from "@/components/ui/ui-button.vue";

const {t} = useI18n();
const authStore = useAuthStore()
const companyStore = useCompanyStore()

const userBalance = computed(() => {
  return authStore.user ? authStore.user.balance.amount : 0
})
const accessToken = computed(() => {
  return authStore.accessToken ? authStore.accessToken : ''
})
const company = computed(() => {
  return companyStore.companyInfo ? companyStore.companyInfo : null
})

const amount = ref(10)
const isAgreePolicy = ref(false)
const isAgreeTerms = ref(false)

const validateNumberInput = (event) => {
  amount.value = event.target.value.replace(/[^0-9]/g, '');
}

const isFormValid = computed(() => {
  return (
      isAgreePolicy.value === true &&
      isAgreeTerms.value === true
  )
})

// const topUp = async () => {
//   const res = await Processes.topUpBalance(amount.value, accessToken.value)
//
//   if (res.data.deposit.transaction.process) {
//     window.location.href = res.data.deposit.transaction.process.url
//   } else {
//     ElNotification({
//       dangerouslyUseHTMLString: true,
//       message: res.errors[0].message,
//       customClass: 'notification'
//     })
//   }
// }
</script>

<style lang="scss" scoped>
.balance {
  &__title {
    color: #F3F3F3;
    font-size: 40px;
    font-weight: 700;
  }

  &__current {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 20px;

    & h6 {
      color: $white;
      font-size: 20px;
      font-weight: 400;
    }

    & p {
      display: flex;
      align-items: center;
      gap: 5px;
      color: #F3F3F3;
      font-size: 20px;
    }
  }

  &__block {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;

    & h6 {
      color: $white;
      font-size: 20px;
      font-weight: 700;
      text-transform: uppercase;
    }

    &-inner {
      display: flex;
      align-items: center;
      gap: 20px;

      & div {
        padding: 10px 14px;
        border-radius: 10px;
        border: 2px solid #ff0000;
        box-shadow: 0 0 10px 1px #ff0000;
        display: flex;
        align-items: center;
        gap: 10px;
        height: 52px;

        & img {
          width: 28px;
        }

        & p {
          color: #F3F3F3;
          font-size: 20px;
          font-weight: 700;
        }

        & input {
          background-color: transparent;

          color: #F3F3F3;
          font-size: 20px;
        }
      }

      & svg {
        flex-shrink: 0;
      }
    }
  }

  &__text {
    margin-top: 20px;
    color: $white;
    font-size: 16px;
    line-height: 134.756%;
  }

  &__checkboxes {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 50px;
  }

  &__link {
    text-decoration: underline;
  }

  &__button {
    margin-top: 30px;
    width: fit-content;
    padding-inline: 40px;
  }
}

@media (max-width: 900px) {
  .balance {
    &__block {
      &-inner {
        flex-direction: column;
        gap: 25px;

        & div {
          width: 300px;
        }

        & svg {
          transform: rotate(90deg);
        }
      }
    }
  }
}

@media (max-width: 700px) {
  .balance {
    &__checkboxes {
      flex-direction: column;
      align-items: flex-start;
      gap: 25px;
    }
  }
}
</style>